import { StyleStatus } from '../../__generated__/globalTypes';

export interface StylingSessionReason {
    id: string;
    creator: string;
    created: Date;
    updater?: any;
    updated?: any;
    title: string;
    value: string;
    isSomethingElse: boolean;
}

export interface Level {
    id: string;
    creator: string;
    created: Date;
    updater?: any;
    updated?: any;
    title: string;
    value: number;
    imageUrl?: string;
}

export interface User {
    id: string;
    creator: string;
    created: Date;
    updater?: any;
    updated?: any;
    phone: string;
    firstName: string;
    lastName: string;
    email: string;
    gender: string;
    userType: string;
    approved: boolean;
    userName: string;
    level?: Level;
    levelId?: any;
    bio?: any;
    profileImageUrl?: any;
    availableForStylingSessions?: any;
}

export interface StoreFilterConfig {
    disallowedStores: string[];
}
export interface listingStyleContainersConfig {
    path: string;
    container: string;
    productCardSelector: string;
    productRowSelector: string;
}

export enum ProductTargetGenderEnum {
    Man = 'Man',
    Woman = 'Woman',
}

enum DisplayTitle {
    STYLE_TITLE = 'STYLE_TITLE',
    ITEM_TITLE = 'ITEM_TITLE',
}
export interface Store {
    id: string;
    taffiId: string;
    approved: boolean;
    name: string;
    description: string;
    url: string;
    shopifyDomain: string;
    logoImageUrl: string;
    platform: string;
    languageCode?: string;
    currencyCode: string;
    defaultPagePath: string;
    supportedLanguages: string[];
    suggestedQuestionIds: string[];
    isTestStore?: boolean;
    showTaffiWidget?: boolean;
    enableVtonFeature?: boolean;
    showFloatingButton?: boolean;
    showAskAmiraCardPDP?: boolean;
    enableProductSpecificQuestion?: boolean;
    plpURLParams?: string;
    showDressItRightCardPDP?: boolean;
    plpWidgetReplaceItemCard?: boolean;
    displayTitlePDP?: DisplayTitle;
    displayTitlePLP?: DisplayTitle;
    enableCustomWidgetScript?: boolean;
    customWidgetScript?: string;
    affiliateLink?: string;
    defaultWidgetStateOpen?: string;
    filterConfigResponse?: StoreFilterConfig;
    enableStyleWidget?: boolean;
    styleWidgetPosition?: string;
    productPagePattern?: string[];
    productPageElementSelectorPattern?: string[];
    styleWidgetTargetElement?: string;
    alternativeStyleWidgetTargetElement?: {
        targetElement: string;
        insertPosition: string;
    }[];
    styleWidgetAutoPlayDelay?: number;
    widgetCustomCss?: string;
    enableListingStyles?: boolean;
    numOfStoreItemsPerTaffiStyle?: number;
    scrollCountForAmiraCard?: number;
    listingStyleContainers?: listingStyleContainersConfig[];
    daysToGetStyles?: number;
    devAttributes?: any;
    stringTranslator?: any;
    devIPs?: string[];
    displayWidgetURLs?: string[];
    hideWidgetURLs?: string[];
    productTargetGender?: ProductTargetGenderEnum[];
    enableSingleProductStyling?: boolean;
    enableEngagingSlider?: boolean;
    allowedStyleStatus?: StyleStatus[];
    taffiWidgetButtonText?: string;
    taffiWidgetButtonImageURL?: string;
}

export interface SessionDetail {
    id: string;
    creator: string;
    created: Date;
    updater: string;
    updated: Date;
    taffiId: string;
    stylingSessionReason: StylingSessionReason;
    subReason?: any;
    customer: User;
    stylist: User;
    eventUri: string;
    inviteeUri: string;
    cancelUri: string;
    rescheduleUri: string;
    stylistEventUri: string;
    startTime?: Date;
    endTime?: Date;
    meetingUrl?: string;
    meetingType?: string;
    status?: SessionStatus;
    store?: Store;
    needSessionWithStylist: boolean;
    requestStatus?: SessionStatus;
    answers: any[];
    answerIds: string[];
}

export enum MySessionsType {
    ALL = 'ALL',
    UPCOMING = 'UPCOMING',
    COMPLETED = 'COMPLETED',
}

export enum SessionStatus {
    Active = 'active',
    Canceled = 'canceled',
}

export enum AnswerType {
    Default = 'default',
    Custom = 'custom',
}
